import { lastValueFrom } from 'rxjs';

import { API_URL, getApiUrl } from '@/utils/api';
import { CartShippingModel, OriginalWoodenCasesOption, ExproOrderModel } from '@/models';
import ApiBase from './ApiBase';

export default class ExproOrderService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.USER, '/exproOrder');

  getShippingModesForExproOrder(exproOrder): Promise<CartShippingModel[]> {
    return lastValueFrom(this.api.postJSON(`${ExproOrderService.baseUrl}/getShippingModesForExproOrder`, exproOrder));
  }

  createCheckoutSession(storeId: string, exproOrder: ExproOrderModel): Promise<any> {
    return lastValueFrom(this.api.postJSON(`${ExproOrderService.baseUrl}/${storeId}/createCheckoutSession`, exproOrder));
  }

  getShippingModesForExproOrderSap(exproOrder): Promise<CartShippingModel[]> {
    return lastValueFrom(this.api.postJSON(`${ExproOrderService.baseUrl}/getShippingModesForExproOrderSap`, exproOrder));
  }

  getOriginalWoodenCasesOption(exproOrderId): Promise<OriginalWoodenCasesOption> {
    return lastValueFrom(this.api.getJSON(`${ExproOrderService.baseUrl}/getOriginalWoodenCasesOption?exproOrderId=${exproOrderId}`, {}));
  }
}
